import {Vector3} from "three";

export function linesIntersect(line1, line2) {
    //Lokale Start und Endpunkte der Linien in Gruppen umwandeln in globale Koordinaten
    let line1Start = line1.localToWorld(new Vector3().copy(line1.position).add(line1.userData.start));
    let line1End = line1.localToWorld(new Vector3().copy(line1.position).add(line1.userData.end));
    let line2Start = line2.localToWorld(new Vector3().copy(line2.position).add(line2.userData.start));
    let line2End = line2.localToWorld(new Vector3().copy(line2.position).add(line2.userData.end));

    line1.userData.globalStart = line1Start;
    line1.userData.globalEnd = line1End;
    line2.userData.globalStart = line2Start;
    line2.userData.globalStart = line2End;

    //Schnittpunkte der Linien mit umgerechneten Koordinaten berechnen: Y Koordinate wird dabei ignoriert
    return calculateLinesIntersecting(line1Start.x, line1Start.z, line1End.x, line1End.z, line2Start.x, line2Start.z, line2End.x, line2End.z);
}

export function convertLineCoordinates(line, startPoint, endPoint) {
    let lineStart = line.localToWorld(new Vector3().copy(line.position).add(startPoint));
    let lineEnd = line.localToWorld(new Vector3().copy(line.position).add(endPoint));
    return {start: lineStart, end: lineEnd};
}

//Prüft zwei Linien auf Schnittpunkte: Nur 2D
export function calculateLinesIntersecting(a, b, c, d, p, q, r, s) {
    let det, gamma, lambda;
    det = (c - a) * (s - q) - (r - p) * (d - b);
    if (det !== 0) {
        lambda = ((s - q) * (r - a) + (p - r) * (s - b)) / det;
        gamma = ((b - d) * (r - a) + (c - a) * (s - b)) / det;
        if ((0 < lambda && lambda < 1) && (0 < gamma && gamma < 1)) {
            let point = {x: a + (c - a) * lambda, z: b + (d - b) * lambda};
            return {intersects: true, point: point};
        }
    }

    return {intersects: false, point: ""};
}

export function signedPolygonArea(points) {
    let sum = 0;
    for (let i = 0; i < points.length - 1; i++) {
        if (i === points.length - 2) {
            sum += (points[i].z * points[0].x) - (points[0].z * points[i].x);
            break;
        } else {
            sum += (points[i].z * points[i + 1].x) - (points[i + 1].z * points[i].x);
        }
    }

    return sum * 0.5;
}

/**
 * Checks if a two ranges overlap.
 * @param A - Range as object {start: float value, finish: float value}
 * @param B - Range as object {start: float value, finish: float value}
 * @param matchingPointAsOverlap - If true having a matching point also counts as overlap. Otherwise, the ranges have to overlap more than 0 units
 * @returns {boolean}
 */
export function areOverlapping(A, B, matchingPointAsOverlap = false) {
    //Check if ranged intersect
    let max = Math.max(A.start.toFixed(3), B.start.toFixed(3));
    let min = Math.min(A.finish.toFixed(3), B.finish.toFixed(3));

    if (!matchingPointAsOverlap) {
        return max - min < 0;
    } else {
        return max - min <= 0;
    }
}

export function getOrthogonalAngle(inputAngle) {
    //Get the closest orthogonal angle to input angle
    if (inputAngle <= Math.PI && inputAngle > 1.5 * Math.PI / 2) {
        return Math.PI;
    } else if (inputAngle >= Math.PI / 4 && inputAngle <= 1.5 * Math.PI / 2) {
        return Math.PI / 2;
    }
    return 0;
}

export function getOrthogonalVector(angle, inputVector) {
    //Makes input vector an orthogonal vector with given angle
    if (angle === Math.PI) {
        inputVector.z = 0;
    } else if (angle === Math.PI / 2) {
        inputVector.x = 0;
    } else {
        inputVector.z = 0;
    }
    return inputVector;
}

export function sortFloatArray(arr) {
    return arr.sort((a, b) => {
        return a - b;
    });
}

export function signedAngle(v1, v2) {
    //2D x/z Plane, @see https://wumbo.net/formulas/angle-between-two-vectors-2d/#formula
    let ang = Math.atan2(v1.x * v2.z - v2.x * v1.z, v1.x * v2.x + v1.z * v2.z);
    //radians to degrees conversion with modulo 360 (result: between 0-360)
    return (-180 / Math.PI * ang) % 360;
}

export function degToRad(deg) {
    return deg * (Math.PI / 180);
}
